<div class="library-section">
  <core-title-section
    [title]="'LIBRARY'"
  ></core-title-section>

  <article class="library-main">
    <app-helpers-search-bar-main
      [placeholder]="'Search the library'"
      [term]="term"
      (termChanges)="onSetTerm($event)"
      [filters]="appliedFilters"
      (removeFilter)="onRemove($event)"
    ></app-helpers-search-bar-main>

    <library-search-filters></library-search-filters>
  </article>
</div >
